/* KOR-E Mobile Sticky Add to Cart — new-theme-mod, with variant circles.
   Forked from kore-mobile-sticky-atc.js (untouched, still used by main-product.liquid) so this
   redesign can never affect the default template's bar or its JS. */
(function () {
  'use strict';

  var MOBILE_BP = 750;

  function resizeShopifyUrl(url, width) {
    if (!url) return url;
    if (/[?&]width=\d+/.test(url)) {
      return url.replace(/([?&]width=)\d+/, '$1' + width);
    }
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    return url + sep + 'width=' + width;
  }

  function KoreStickyATC(bar) {
    var sectionId = bar.dataset.sectionId;
    if (!sectionId) return;

    var stickyBtn     = document.getElementById('KoreStickyATCBtn-' + sectionId);
    var stickyImg     = document.getElementById('KoreStickyATCImg-' + sectionId);
    var circlesWrap   = document.getElementById('KoreStickyATCCircles-' + sectionId);
    if (!stickyBtn) return;

    var realBtnId  = stickyBtn.dataset.realBtn;
    var realFormId = stickyBtn.dataset.realForm;
    var realBtn    = realBtnId  ? document.getElementById(realBtnId)  : null;
    var realForm   = realFormId ? document.getElementById(realFormId) : null;
    if (!realBtn || !realForm) return;

    /* secEl is the SAME element new-theme-mod-variant-cards.liquid toggles kore-vc-blocked on
       and dispatches kore:variant:selected from — reading that one existing class/event is the
       whole "explicit selection required" + "variant changed" signal this bar needs. No new
       selection state is tracked here. */
    var secEl = document.getElementById('MainProduct-' + sectionId);

    var sentinel     = realBtn.closest('.product-form__buttons') || realBtn;
    var isBarVisible = false;
    var isMobile     = window.innerWidth < MOBILE_BP;
    var io           = null;
    var mutObs       = null;
    var classObs     = null;
    var clickLocked  = false;

    /* ── Button-state sync (label/disabled mirror the real button, unchanged from before) ── */
    function syncState() {
      var disabled = realBtn.disabled || realBtn.getAttribute('aria-disabled') === 'true';
      stickyBtn.disabled = disabled;
      if (disabled) stickyBtn.setAttribute('aria-disabled', 'true');
      else          stickyBtn.removeAttribute('aria-disabled');
      var realSpan   = realBtn.querySelector('span:not(.loading__spinner):not(.loading-overlay__spinner)');
      var stickySpan = stickyBtn.querySelector('.kore-satc-vc__btn-text');
      if (realSpan && stickySpan) {
        var txt = realSpan.textContent.trim();
        if (txt) stickySpan.textContent = txt;
      }
    }

    /* ── "Must explicitly select a variant" — mirrors the main picker's own existing
       kore-vc-blocked class (set by blockATC()/unblockATC() in
       new-theme-mod-variant-cards.liquid) rather than tracking a second, separate flag here. ── */
    function syncBlockedState() {
      if (!secEl) return;
      // Only ever pending when this bar actually rendered circles to resolve it with — a
      // product whose main picker considers itself "not yet selected" but that this bar's own
      // (stricter) real-choice check decided has nothing to choose between must never show a
      // dead-end disabled CTA with no circles to click.
      var blocked = !!circlesWrap && secEl.classList.contains('kore-vc-blocked');
      stickyBtn.classList.toggle('kore-satc-vc__btn--pending', blocked);
    }

    /* ── Image sync — reads the mobile gallery's OWN currently-active slide, which
       product-media-gallery-new-theme-mod.liquid + new-theme-mod-variant-cards.liquid already
       keep correctly synced to the selected variant (custom.variant_gallery first image,
       variant.featured_media, or the plain product fallback — whichever that existing chain
       resolved). No second gallery-priority lookup is implemented here. ── */
    function syncImageFromGallery() {
      if (!stickyImg) return;
      var track = document.getElementById('KntmTrack-' + sectionId);
      if (!track) return;
      var activeImg = track.querySelector('.kntm-slide.is-active:not(.kntm-slide--clone) img');
      if (!activeImg) return;
      var src = activeImg.currentSrc || activeImg.getAttribute('src');
      if (!src) return;
      var resized = resizeShopifyUrl(src, 160);
      if (resized && resized !== stickyImg.src) stickyImg.src = resized;
    }

    /* ── Circle selected-state sync ── */
    function syncCircleSelection(variantId) {
      if (!circlesWrap) return;
      var vid = String(variantId);
      Array.prototype.forEach.call(circlesWrap.querySelectorAll('.kore-satc-vc__circle'), function (c) {
        var isSel = c.getAttribute('data-variant-id') === vid;
        c.classList.toggle('kore-satc-vc__circle--selected', isSel);
        c.setAttribute('aria-pressed', isSel ? 'true' : 'false');
      });
    }

    /* ── Show / hide ─────────────────────────────────────────────────────── */
    function showBar() {
      if (isBarVisible || !isMobile) return;
      isBarVisible = true;
      bar.classList.add('kore-satc-vc--visible');
      bar.removeAttribute('aria-hidden');
      syncState();
      syncBlockedState();
    }
    function hideBar() {
      if (!isBarVisible) return;
      isBarVisible = false;
      bar.classList.remove('kore-satc-vc--visible');
      bar.setAttribute('aria-hidden', 'true');
    }

    /* ── IntersectionObserver (unchanged behaviour from the original bar) ── */
    function setupObserver() {
      if (io) { io.disconnect(); io = null; }
      if (!isMobile) { hideBar(); return; }
      io = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        if (entry.isIntersecting) {
          hideBar();
        } else if (entry.boundingClientRect.bottom < 0) {
          showBar();
        } else {
          hideBar();
        }
      }, { threshold: 0.0, rootMargin: '0px' });
      io.observe(sentinel);
    }

    /* ── ATC button click — a CONTROLLER, not a second form. Asks the SAME real <form> the
       main page already uses to submit itself properly, with the real button as submitter, via
       form.requestSubmit(realBtn) — a single genuine 'submit' event through
       assets/product-form.js's own listener (bound on the form's submit event, not the
       button's click), preserving validation and submitter semantics exactly as a direct click
       on the real button would. Previously this called realBtn.click() — a synthetic click on
       an element that may be scrolled out of view, which risks the same implicit
       focus-on-click/scroll-into-view behaviour fixed below for the variant circles. No second
       Add to Cart implementation, no duplicate form, no manual fetch: quantity max 5,
       Shopify quantity rules, preorder properties and add-ons are whatever the real form's own
       FormData already contains at submit time — untouched. */
    function onStickyClick() {
      if (clickLocked) return;
      if (stickyBtn.disabled || stickyBtn.getAttribute('aria-disabled') === 'true') return;
      if (realBtn.disabled) return; // defensive: stale mirror, real button no longer submittable
      clickLocked = true;
      stickyBtn.classList.add('kore-satc-vc__btn--loading');
      stickyBtn.setAttribute('aria-busy', 'true');
      if (typeof realForm.requestSubmit === 'function') {
        realForm.requestSubmit(realBtn);
      } else {
        // very old browsers without requestSubmit — still a single real submit, not a
        // form.submit() bypass (which would skip product-form.js's AJAX handler entirely)
        realBtn.click();
      }
      setTimeout(function () {
        clickLocked = false;
        stickyBtn.classList.remove('kore-satc-vc__btn--loading');
        stickyBtn.removeAttribute('aria-busy');
        syncState();
      }, 1400);
    }
    stickyBtn.addEventListener('click', onStickyClick);

    /* ── Variant circle click — calls the SAME shared selection function the real .kore-vcard
       click handler calls (window.__kntmSelectVariant[SEC], exposed by
       new-theme-mod-variant-cards.liquid), instead of proxying a .click() onto the real,
       possibly off-screen card. That .click() was the exact cause of the page jumping to the
       main picker: a real .kore-vcard is a tabindex="0" element, and calling .click() on a
       focusable element the browser hasn't itself decided to focus still runs the browser's
       implicit "focus the activated control" step — and focusing an element outside the
       viewport auto-scrolls it into view. Calling the selection function directly is a plain
       JS call, not a simulated interaction with any element, so nothing is focused and nothing
       scrolls. One delegated listener instead of one per circle, so cleanup (below) stays a
       single removeEventListener. ── */
    function onCirclesClick(e) {
      var circle = e.target.closest('.kore-satc-vc__circle');
      if (!circle || !circlesWrap.contains(circle)) return;
      var vid = circle.getAttribute('data-variant-id');
      if (!vid || !sectionId) return;
      if (window.__kntmSelectVariant && window.__kntmSelectVariant[sectionId]) {
        window.__kntmSelectVariant[sectionId](vid);
      }
    }
    if (circlesWrap) circlesWrap.addEventListener('click', onCirclesClick);

    /* ── kore:variant:selected — dispatched once, at the end of selectCard(), after every
       other side effect (gallery sync included) has already run synchronously. Single source
       of truth for this bar's own re-sync, whether the selection came from the main picker or
       from this bar's own circles (which proxy into the exact same function). ── */
    function onVariantSelected(e) {
      var vid = e.detail && e.detail.variantId;
      if (vid == null) return;
      syncCircleSelection(vid);
      syncImageFromGallery();
      syncState();
      syncBlockedState();
    }
    if (secEl) secEl.addEventListener('kore:variant:selected', onVariantSelected);

    /* ── MutationObserver: real button state (sold out / preorder / normal label+disabled) ── */
    mutObs = new MutationObserver(syncState);
    mutObs.observe(realBtn, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'aria-busy'],
      childList: true,
      subtree: true
    });

    /* ── MutationObserver: kore-vc-blocked class, in case anything besides selectCard() itself
       ever toggles it (defensive; selectCard()'s own event above already covers the normal
       click path). ── */
    if (secEl) {
      classObs = new MutationObserver(syncBlockedState);
      classObs.observe(secEl, { attributes: true, attributeFilter: ['class'] });
    }

    /* ── Resize ──────────────────────────────────────────────────────────── */
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var nowMobile = window.innerWidth < MOBILE_BP;
        if (nowMobile !== isMobile) { isMobile = nowMobile; hideBar(); setupObserver(); }
      }, 150);
    });

    /* ── Theme Editor cleanup ────────────────────────────────────────────── */
    function cleanup() {
      if (io)       { io.disconnect();       io       = null; }
      if (mutObs)   { mutObs.disconnect();   mutObs   = null; }
      if (classObs) { classObs.disconnect(); classObs = null; }
      stickyBtn.removeEventListener('click', onStickyClick);
      if (circlesWrap) circlesWrap.removeEventListener('click', onCirclesClick);
      if (secEl) secEl.removeEventListener('kore:variant:selected', onVariantSelected);
      hideBar();
      bar._koreATCInit = false;
    }
    document.addEventListener('shopify:section:unload', function (evt) {
      if (evt.detail && evt.detail.sectionId === sectionId) cleanup();
    });

    /* ── Init ────────────────────────────────────────────────────────────── */
    syncState();
    syncBlockedState();
    setupObserver();
  }

  /* ── Boot ────────────────────────────────────────────────────────────────── */
  function initAll() {
    document.querySelectorAll('.kore-satc-vc[data-section-id]').forEach(function (bar) {
      if (bar._koreATCInit) return;
      bar._koreATCInit = true;
      KoreStickyATC(bar);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function () { setTimeout(initAll, 0); });

}());
